// extracted by mini-css-extract-plugin
export var option = "_bj-0";
export var optionCard = "_bj-f";
export var optionContent = "_bj-g";
export var optionIcon = "_bj-i";
export var optionIconBox = "_bj-h";
export var optionLabel = "_bj-j";
export var optionPill = "_bj-m";
export var optionPillBadge = "_bj-p";
export var optionPillIcon = "_bj-n";
export var optionPillLabel = "_bj-o";
export var optionRadio = "_bj-k";
export var optionRadioInner = "_bj-l";
export var optionReveal = "_bj-2";
export var optionRevealDelay0 = "_bj-3";
export var optionRevealDelay1 = "_bj-4";
export var optionRevealDelay10 = "_bj-d";
export var optionRevealDelay11 = "_bj-e";
export var optionRevealDelay2 = "_bj-5";
export var optionRevealDelay3 = "_bj-6";
export var optionRevealDelay4 = "_bj-7";
export var optionRevealDelay5 = "_bj-8";
export var optionRevealDelay6 = "_bj-9";
export var optionRevealDelay7 = "_bj-a";
export var optionRevealDelay8 = "_bj-b";
export var optionRevealDelay9 = "_bj-c";
export var optionSelected = "_bj-1";